<template>
  <div class="flex-box">
    <section class="main-block">
      <van-image class="background-img" width="100%" :src="require('../../assets/imgs/ysxq_top_pic.png')" />

      <div class="doctor-card" :class="{ hasSpecialties: doctorInfo.specialties }">
        <div class="doctor-detail">
          <div class="img-box">
            <van-image
              round
              width="68"
              height="68"
              :src="doctorInfo.avatar | imgUrl"
              class="doctor-img van-hairline--surround"
            />
            <div v-if="!canAdvisory && doctorInfo.avatar" class="rest-tip">
              <van-icon
                size="12"
                :name="require('../../assets/imgs/rest.png')"
                style="margin-right: 4px; padding-top: 2px"
              />
              休息中
            </div>
          </div>

          <div class="doctor-title">
            <p class="name van-ellipsis">{{ doctorInfo.name }}</p>
            <p>
              <span class="department">{{ doctorInfo.department | subStr(7) }}</span>
              <span class="jobTitle">{{ doctorInfo.jobTitle | subStr(10) }}</span>
            </p>
            <p class="hospital van-multi-ellipsis--l2">{{ doctorInfo.hospital | subStr(33) }}</p>
          </div>
        </div>

        <div v-if="doctorInfo.specialties" class="doctor-desc" :class="{ 'padding-bottom-20': !clamped }">
          <v-clamp v-if="doctorInfo.specialties" autoresize :max-lines="2" ellipsis="" ref="clamped" class="clamped">
            擅长领域：{{ doctorInfo.specialties }}
            <template #after v-if="isClamped">
              <span class="after" v-if="clamped" @click="toggleClamped">
                <span class="txt"></span>
                <span class="pos" :class="{ 'bottom-18': !clamped }">
                  <van-icon style="margin-top: 1.5px" size="16" :name="clamped ? 'arrow-down' : 'arrow-up'"></van-icon>
                </span>
              </span>
            </template>
          </v-clamp>

          <div v-if="!clamped" @click="toggleClamped" class="up-clamped-icon">
            <van-icon size="16" name="arrow-up"></van-icon>
          </div>
        </div>

        <div class="doctor-price van-hairline--top" :class="{ 'margin-top-12': !doctorInfo.specialties }">
          <p class="price-title">问诊方式</p>
          <p class="price">
            <span>
              图文问诊
              <b class="price-num">{{ doctorInfo.price | price(0) }}</b>
              元
            </span>
          </p>
        </div>
      </div>

      <div class="page-notice">
        <p style="margin-bottom: 12px; line-height: 20px">温馨提示</p>
        <p>
          1. 每次图文咨询时效为24小时，在24小时内可随时沟通。如医生24小时内未回复，费用会原路退回给您；
          <br />
          2. 医生可能正在门诊或手术，未能及时回复请您谅解；
          <br />
          3. 若病情危急，请您直接前往医院就诊；
          <br />
          4. 如有疑问，可咨询智云医道客服
          <a class="process-tel" href="tel:400-921-6690">400-921-6690</a>
        </p>
      </div>

      <div class="checkbox" v-if="canAdvisory">
        <van-checkbox icon-size="16" v-model="checked"><span>已同意并阅读</span></van-checkbox>
        <span class="link-btn" @click="processLink">《知情同意书》</span>
      </div>
    </section>
    <div v-if="canAdvisory">
      <div class="tips" v-if="doctorInfo.advisoryStatus" v-show="timer.hh">
        您可在
        <span>{{ timer.hh }}</span>
        :
        <span>{{ timer.mm }}</span>
        :
        <span>{{ timer.ss }}</span>
        内随时发起咨询，无需付费
      </div>
      <footer class="footer-btns">
        <van-button v-if="!isNonDrug" plain type="primary" class="share-btn btn" @click="shareDoctor">
          分享给好友
        </van-button>
        <van-button
          type="primary"
          class="advisory-btn btn"
          :disabled="isRequest"
          @click="toConsult(doctorInfo.advisoryStatus)"
        >
          <span v-if="doctorInfo.advisoryStatus == 1">咨询中...</span>
          <span v-else>立即咨询</span>
        </van-button>
      </footer>
    </div>

    <van-popup v-model="showShare" class="self-pop" get-container="body">
      <div class="pop-box">
        <van-image :src="doctorInfo.hospitalDoctorWechatShareUrl | imgUrl('share')" class="share-img"></van-image>

        <p class="share-tip">长按图片，把医生分享给朋友</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import VClamp from 'vue-clamp';
import { Popup } from '@zyf2e/capui-mobile';
import jumpCenter from '@/mixins/jumpCenter';
Vue.use(Popup);
// import html2canvas from 'html2canvas';

export default {
  name: 'UserCenter',
  components: { 'v-clamp': VClamp },
  mixins: [jumpCenter],
  filters: {
    subStr(val, length = 1000) {
      if (val && typeof val === 'string') {
        return val.substring(0, length);
      }
      return '';
    }
  },
  data() {
    return {
      doctorInfo: {},
      doctorId: '',
      showShare: false,
      isRequest: false,
      advisoryEndTimestamp: '',
      timer: {
        inte: '',
        hh: '',
        mm: '',
        ss: ''
      },
      checked: true,
      isClamped: false,
      clamped: true,
      isNonDrug: false
    };
  },
  computed: {
    canAdvisory() {
      return (this.doctorInfo && this.doctorInfo.canAdvisory) || false;
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.doctorInfo = {};
      vm.doctorId = to.params.id;
      vm.isNonDrug = to.query.isDrug === '0' || to.query.isDrug === 0;
      vm.checked = true;

      vm.isClamped = false;
      vm.clamped = true;
      vm.fetchData();
    });
  },
  mounted() {
    window.wx.hideOptionMenu();
  },
  beforeDestroy() {
    if (this.timer.inte) {
      clearInterval(this.timer.inte);
    }
  },

  methods: {
    fetchData() {
      this.$fetch.getDoctorDetail(this.doctorId).then((data) => {
        this.doctorInfo = data;
        const { advisoryEndTimestamp, advisoryStatus } = data;
        if (advisoryStatus) {
          this.advisoryEndTimestamp = advisoryEndTimestamp / 1000;
          this.timer.inte = setInterval(this.countdown, 1000);
        }

        this.$nextTick(() => {
          if (this.$refs.clamped) this.isClamped = this.$refs.clamped.isClamped;
        });
      });
    },
    countdown() {
      //倒计时
      const curr_time = parseInt(Date.parse(new Date()) / 1000);
      const diff_time = parseInt(this.advisoryEndTimestamp - curr_time); // 倒计时时间差
      if (diff_time < 0) {
        if (this.timer.inte) {
          clearInterval(this.timer.inte);
        }
        this.timer = {
          inte: '',
          hh: '00',
          mm: '00',
          ss: '00'
        };
      }
      this.timer.hh =
        Math.floor(diff_time / 3600) < 10 ? '0' + Math.floor(diff_time / 3600) : Math.floor(diff_time / 3600);
      this.timer.mm =
        Math.floor((diff_time / 60) % 60) < 10
          ? '0' + Math.floor((diff_time / 60) % 60)
          : Math.floor((diff_time / 60) % 60);
      this.timer.ss = Math.floor(diff_time % 60) < 10 ? '0' + Math.floor(diff_time % 60) : Math.floor(diff_time % 60);
    },
    toConsult(advisoryStatus) {
      if (!this.checked) {
        this.$toast({
          className: 'middle-toast',
          message: '请勾选知情同意书'
        });
        return;
      }

      // 埋点
      const timeStamp = new Date().getTime();
      Telescope.trackEvent({ trackId: 'zyyd-click-wdys-ljzx', custom: { doctorId: this.doctorId, timeStamp } });

      this.isRequest = true;
      // advisoryStatus 1: 咨询中 0: 未咨询 2 有正在咨询
      if (advisoryStatus == 1) {
        window.wx.closeWindow();
        this.isRequest = false;
      } else {
        // const { requirementId } = this.$route.query;
        // this.$fetch
        //   .fetchAdvisory({ doctorId: this.doctorId, requirementId })
        //   .then((data) => {
        //     // 1: 可以问诊  2: 需要支付
        //     if (data.status === 1) {
        //       window.wx.closeWindow();
        //     } else {
        //       this.$router.push({
        //         path: '/pay-advisory',
        //         query: {
        //           doctorId: this.doctorId,
        //           doctorName: data.doctorName,
        //           doctorAvatar: data.doctorAvatar,
        //           price: this.formatPrice(data.price),
        //           requirementId,
        //           expireTimestamp: data.expireTimestamp || '',
        //           advisoryId: data.advisoryId || '',
        //           payAgain: data.payAgain,
        //           now: Date.now()
        //         }
        //       });
        //       // this.jumpToCheckOut({
        //       //   doctorId: this.doctorId,
        //       //   doctorName: data.doctorName,
        //       //   doctorAvatar: data.doctorAvatar,
        //       //   price: this.formatPrice(data.price),
        //       //   requirementId,
        //       //   expireTimestamp: data.expireTimestamp || '',
        //       //   advisoryId: data.advisoryId || '',
        //       //   payAgain: data.payAgain
        //       // });
        //     }
        //     this.isRequest = false;
        //   })
        //   .catch(() => {
        //     this.isRequest = false;
        //   });
        const { requirementId } = this.$route.query;
        this.$fetch
          .preAdvisory({ doctorId: this.doctorId, requirementId })
          .then((data) => {
            if (data.jumpPage == 1) {
              window.wx.closeWindow();
            } else if (data.jumpPage == 2) {
              this.$router.push({
                name: 'DiseaseDesc',
                query: {
                  doctorId: this.doctorId,
                  requirementId,
                  diseaseDesc: data.diseaseDesc
                }
              });
            } else if (data.jumpPage == 3) {
              this.$router.push({
                path: '/pay-advisory',
                query: {
                  doctorId: this.doctorId,
                  doctorName: data.advisoryPayInfo?.doctorName,
                  doctorAvatar: data.advisoryPayInfo?.doctorAvatar,
                  price: this.formatPrice(data.advisoryPayInfo?.price),
                  requirementId,
                  expireTimestamp: data.advisoryPayInfo?.expireTimestamp || '',
                  advisoryId: data.advisoryPayInfo?.advisoryId || '',
                  payAgain: data.advisoryPayInfo?.payAgain,
                  now: Date.now()
                }
              });
            }
            this.isRequest = false;
          }).catch(() => {
            this.isRequest = false;
          });
      }
    },
    shareDoctor() {
      this.showShare = !this.showShare;
      const timeStamp = new Date().getTime();
      Telescope.trackEvent({ trackId: 'zyyd-click-yszy-fxghy', custom: { doctorId: this.doctorId, timeStamp } });
    },
    formatPrice(price) {
      if (price && typeof price === 'number') {
        return (price / 100).toFixed(2);
      } else {
        return '';
      }
    },
    toggleClamped() {
      this.$refs.clamped.toggle();
      this.clamped = !this.clamped;
    },
    processLink() {
      window.location.href = 'https://static.91jkys.com/kaer/zyydzqtys/index.html#/';
    }
  }
};
</script>

<style scoped lang="scss">
.flex-box {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;

  .main-block {
    background: #ffffff;
    display: inline-flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    position: relative;
    z-index: 1;
    .background-img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    .doctor-card {
      &.hasSpecialties {
        margin-top: 80px !important;
      }
      margin: 0 16px;
      margin-top: 120px;
      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.07);
      border-radius: 8px;
      padding: 16px 12px;
      z-index: 10;
      /deep/ .van-hairline--top::after {
        border-style: dashed;
        border-color: #8c8c8c;
      }
      .doctor-detail {
        display: flex;
        flex-direction: row;
        margin-bottom: 8px;
        .img-box {
          position: relative;
          .rest-tip {
            position: absolute;
            bottom: 0;
            width: 68px;
            z-index: 1;
            left: 0;
            color: #fff;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            border-radius: 10px;
            background: #6d7278;
            text-align: center;
            display: inline-flex;
            justify-content: center;
            align-items: center;
          }
        }
        .doctor-img {
          margin-right: 8px;
          // border-radius: 4px;
          overflow: hidden;
        }
        .doctor-title {
          flex: 1;
          overflow: hidden;
          p {
            font-size: 14px;
            line-height: 1;
            color: #262626;
          }
          .name {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 8px;
          }
          .department {
            margin-right: 8px;
          }
          .hospital {
            line-height: 21px;
            margin-top: 4px;
          }
        }
      }

      .doctor-desc {
        color: #595959;
        font-size: 14px;
        line-height: 1.5;
        padding-bottom: 12px;
        position: relative;
        &.padding-bottom-20 {
          padding-bottom: 20px !important;
        }
        .clamped {
          position: relative;
        }
        .after {
          color: #c8c8c8;
          display: inline-block;
          .txt {
            display: inline-block;
            width: 0;
          }
          .pos {
            position: absolute;
            display: inline-block;
            text-align: right;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 30%, #ffffff 100%);
            width: 42px;
            height: 18px;
            line-height: 18px;
            right: 0;
            bottom: 2px;
            &.bottom-18 {
              bottom: 0px;
            }
          }
        }
        .up-clamped-icon {
          position: absolute;
          color: #c8c8c8;
          right: 0;
          bottom: 4px;
          height: 16px;
        }
      }

      .doctor-price {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 11.5px;
        p {
          font-size: 14px;
          line-height: 1;
          color: #595959;
        }
        .price-num {
          color: #ff4e47;
          font-weight: 500;
        }
      }

      .doctor-desc {
        .desc {
          // font: 400 14px/24px PingFangSC-Semibold, PingFang SC;
          font-size: 14px;
          line-height: 24px;
          color: #8c8c8c;
          padding-bottom: 16px;
        }
      }
    }
    .page-notice {
      margin-top: 40px;
      padding: 0 16px;
      flex: 1;
      p {
        font-size: 14px;
        line-height: 23px;
        color: #595959;
        &.text-center {
          text-align: center;
          margin-bottom: 12px;
        }
        .process-tel {
          color: #1e8dff;
        }
      }
    }
    .checkbox {
      display: flex;
      margin-top: 35.5px;
      padding: 0 16px 16px;
      flex-direction: row;
      align-items: center;
      span {
        font-size: 14px;
        line-height: 1;
        color: #262626;
        &.link-btn {
          color: #1e8dff;
        }
      }
    }
  }

  .margin-top-12 {
    margin-top: 12px;
  }
  .padding12 {
    padding: 12px;
  }
  .tips {
    background: #ebf8ff;
    padding: 13px 16px;
    text-align: center;
    color: #1e8dff;
    font-size: 14px;
    line-height: 14px;
  }
  .footer-btns {
    width: 100%;
    display: flex;
    background: #fff;
    padding: 8px 16px;
    & > .btn {
      height: 44px;
    }
    .share-btn {
      flex: 1;
      border-radius: 8px;
      margin-right: 12px;
    }
    .advisory-btn {
      flex: 1;
      border-radius: 8px;
    }
  }
}
.self-pop {
  border-radius: 8px;
  .pop-box {
    width: 282px;
    // height: 415px;
    background: #f9f9f9;
    // padding: 20px 12.5px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    .share-img {
      width: 100%;
      min-height: 100px;
      // box-shadow: #ebedf0 0 4px 12px;
      // flex: 1;
    }
    .share-tip {
      margin: 0 12.5px;
      margin-bottom: 20px;
      background: #e4ecf5;
      border-radius: 18px;
      text-align: center;
      padding: 7px 0;
      font: 500 16px/22.5px PingFangSC-Medium, PingFang SC;
    }
  }
}
</style>
